module.exports = require("wix-fetch");